/* eslint-disable prettier/prettier */
export const getFieldValue = (field: any): { value: any; ai_result: any } => {
  if (field === null || field === undefined) {
    return { value: null, ai_result: null };
  }

  const ai = field.ai_result;
  const modifs = field.modifications;

  const rawValue = modifs?.length > 0 ? modifs[modifs.length - 1] : ai;

  const normalize = (val: any) => {
    if (typeof val === 'boolean') return val ? 'True' : 'False';
    return val;
  };

  return { value: normalize(rawValue), ai_result: normalize(ai) };
};
